import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})

export class VendorsPayoutService {
    private baseURL: string;
    constructor(private http: HttpClient) {
        this.baseURL = environment.apiBaseUrl;
    }

    getLastProcessedVendorPayoutDate(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/VendorsPayout/GetLastProcessedVendorPayoutDate`,
            { observe: 'response' }
        ).pipe(
            map(res => res.body as any),
            catchError(this.handleError)
        );
    }

    getVendorsPayout(startDate: string, endDate: string): Observable<any[]> {
        let params = `?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
        return this.http.get<any[]>(
            `${this.baseURL}/VendorsPayout/GetVendorsPayout${params}`,
            { observe: 'response' }
        ).pipe(
            map(res => res.body as any[]),
            catchError(this.handleError)
        );
    }

    saveVendorsPayout(payouts: any[], payoutInfo: any): Observable<any> {
        const body = {
            Payouts: payouts,
            PayoutInfo: payoutInfo
        };
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.post<any>(
            `${this.baseURL}/VendorsPayout/SaveVendorsPayout`,
            body,
            { headers }
        ).pipe(
            catchError(this.handleError)
        );
    }

    getAllProcessedVendorPayouts(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/VendorsPayout/getAllProcessedVendorPayouts`,
            { observe: 'response' }
        ).pipe(
            map(res => res.body as any),
            catchError(this.handleError)
        );
    }

    saveVendorAutoDeduct(vendorAutoDeductDto: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/VendorsPayout/SaveVendorAutoDeduct`,
            vendorAutoDeductDto,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    getPendingDayEndList(startDate: string, endDate: string): Observable<any[]> {
        const params = `?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
        return this.http.get<any[]>(
            `${this.baseURL}/VendorsPayout/GetPendingDayEndList${params}`,
            { observe: 'response' }
        ).pipe(
            map(res => res.body as any[]),
            catchError(this.handleError)
        );
    }

    rollbackVendorsPayout(payoutDate: string): Observable<any> {
        const body = {
            payoutDate: payoutDate
        };

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.http.post<any>(
            `${this.baseURL}/VendorsPayout/RollbackVendorsPayout`,
            body,
            { headers }
        ).pipe(
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
}
